import { render, staticRenderFns } from "./baseExchange.vue?vue&type=template&id=36c6455d&scoped=true"
import script from "./baseExchange.vue?vue&type=script&lang=js"
export * from "./baseExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6455d",
  null
  
)

export default component.exports